import { Box, Divider, Grid, Typography, Paper, Chip, Stack } from "@mui/material";
import useFetchJson from "../../../data/useFetchJson";
import { LoadingBox } from "@northpowerdev/np-react-utils";
import { differenceInCalendarDays, parseISO } from "date-fns";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";

export default function WairuaWeekly() {

  const {
    data: handoverListData,
    isLoading,
} = useFetchJson('/bff/noc-handover-service/api/handover/get-list', {}, true)

const last7Days = (handoverListData || []).filter(item => {
    const handoverDate = parseISO(item.handover?.handoverTime || item.updateDate)
    const daysDiff = differenceInCalendarDays(new Date(), handoverDate)
    return daysDiff >= 0 && daysDiff <= 7
}).sort((a, b) => new Date(b.handover?.handoverTime || b.updateDate) - new Date(a.handover?.handoverTime || a.updateDate))

console.log('last7Days: ', last7Days)


  return (
    <Box>
    <Box sx={{ mb: 2, width: '100%' }}>
        <Box display='flex' justifyContent='space-between' alignItems={'center'} >
            {/* <PageTitle title='Wairua Weekly Updates' /> */}
            <Typography variant="h5" color="secondary" sx={{ fontWeight: 'bold' }}>Wairua Weekly Updates</Typography>
        </Box>
    </Box>
    <Divider sx={{ my: 2 }} />

    <LoadingBox loading={isLoading}>
        {/* Wairua Notes Change Log */}
        <Box sx={{ mb: 3 }}>
            {last7Days?.length === 0 && (
                <Typography variant="body2">No changes to Wairua Notes in the last 7 days.</Typography>
            )}
            {last7Days?.map((chg, i) => (
                <Paper key={i} variant="outlined" sx={{ mt: 1.5, p: 2, borderRadius: 2 }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle2" color="secondary">
                            {chg.outgoingController 
                                ? chg.outgoingController.split(' ').map(name => name.charAt(0)).join('').toUpperCase()
                                : 'Unknown'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {new Date(chg.handover?.handoverTime || chg.updateDate).toLocaleString()}
                        </Typography>
                    </Stack>
                    <Divider sx={{ my: 1.25 }} />
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={7}>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', lineHeight: 1.6 }}>{chg.wairuaNotes}</Typography>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Stack spacing={1.25}>
                                <Paper variant="outlined" sx={{ p: 1.25, bgcolor: 'grey.50' }}>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <Typography variant="subtitle2" color="secondary">G3</Typography>
                                        {chg?.handover?.generatorG3FullCapacity && (
                                            <Chip size="small" color="success" variant="outlined" icon={<CheckCircleRoundedIcon />} label="Full capacity" />
                                        )}
                                        {!chg?.handover?.generatorG3FullCapacity && (
                                            chg?.handover?.generatorG3MasterLogEntered ? (
                                                <Chip size="small" color="success" variant="outlined" icon={<CheckCircleRoundedIcon />} label="Master log entered" />
                                            ) : (
                                                <Chip size="small" color="default" variant="outlined" icon={<RemoveRoundedIcon />} label="Master log entered" />
                                            ))}
                                    </Stack>
                                    {!chg?.handover?.generatorG3FullCapacity && chg?.handover?.generatorG3Notes && (
                                        <>
                                            <Typography variant="caption" color="text.secondary">Notes</Typography>
                                            <Typography sx={{ whiteSpace: 'pre-line' }}>{chg?.handover?.generatorG3Notes}</Typography>
                                        </>
                                    )}
                                </Paper>
                                <Paper variant="outlined" sx={{ p: 1.25, bgcolor: 'grey.50' }}>
                                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                        <Typography variant="subtitle2" color="secondary">G4</Typography>
                                        {chg?.handover?.generatorG4FullCapacity && (
                                            <Chip size="small" color="success" variant="outlined" icon={<CheckCircleRoundedIcon />} label="Full capacity" />
                                        )}
                                        {!chg?.handover?.generatorG4FullCapacity && (
                                            chg?.handover?.generatorG4MasterLogEntered ? (
                                                <Chip size="small" color="success" variant="outlined" icon={<CheckCircleRoundedIcon />} label="Master log entered" />
                                            ) : (
                                                <Chip size="small" color="default" variant="outlined" icon={<RemoveRoundedIcon />} label="Master log entered" />
                                            )
                                        )}
                                    </Stack>
                                    {!chg?.handover?.generatorG4FullCapacity && chg?.handover?.generatorG4Notes && (
                                        <>
                                            <Typography variant="caption" color="text.secondary">Notes</Typography>
                                            <Typography sx={{ whiteSpace: 'pre-line' }}>{chg?.handover?.generatorG4Notes}</Typography>
                                        </>
                                    )}
                                </Paper>
                            </Stack>
                        </Grid>
                    </Grid>
                </Paper>
            ))}
        </Box>
    </LoadingBox>
</Box>
)
}


